import React from 'react';

import Logo from './../images/logo.png';
import Chevron from './../images/chevron.png';

import { Link, useNavigate } from 'react-router-dom';

import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

import HomeImage from './../images/home-image.png';
import PremiumImage from './../images/premium-logo.png';

import { useUser } from './../hooks/useUser';

import Spinner from './../components/spinner';


import './../pages/pre-test.scss';
import './modal.scss';



import { useFirebaseServices } from '../hooks/firebase-services.js';


const Modal = ({ loading, deleteModalOpen, setDeleteModalOpen, premiumModalOpen, setPremiumModalOpen, setPersonalityData, setSignUpFlow, priceAmount, currency }) => {

    const [purchaseButtonClicked, setPurchaseButtonClicked] = useState(false);

    const { user } = useUser();


    const navigate = useNavigate();

    const { deleteResults, checkout } = useFirebaseServices(setPersonalityData);


    if (priceAmount == null || currency == null) {

        return;

    }


    const shortPrice = priceAmount.toString().slice(0, -2);
    const capsCurrency = currency.toString().toUpperCase();


    const DeleteModal = ({ }) => {

        return (

            <div className="modal">
                <div className="modal-content">
                    <span className="close" onClick={() => { setDeleteModalOpen(false) }}>&times;</span>
                    <div className="modal-title">
                        Reset test confirmation
                    </div>
                    <div className="modal-body">
                        <div>Are you sure you want to reset? All saved information about your results will be lost. </div>
                        <button className="button secondary" onClick={async () => {


                            deleteResults();
                            localStorage.clear();
                            setPersonalityData(null);
                            setDeleteModalOpen(false);
                            navigate('/');

                        }}>Reset</button>
                    </div>
                </div>
            </div>

        );



    }




    const PremiumModal = ({ }) => {

        return (

            <div className="modal">

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >

                    <div className="test-option-box-modal">
                        <span className="close" onClick={() => { setPremiumModalOpen(false) }}>&times;</span>
                        <div className="test-option-image-container" >
                            <img className="test-option-image" src={PremiumImage} alt="home-image" />
                        </div>
                        <div className="test-option-heading">
                            Full test:  $ {shortPrice}   {capsCurrency}
                        </div>

                        <div>
                            Full test to give you the most in-depth results. You will gain access to your exact percentile score and additional information to help you understand your personality. 
                        </div>

                        {purchaseButtonClicked ? <Spinner />
                            :

                            <>

                                <Link to="/premium-test">
                                    <button className="button tertiary" onClick={() => { setPremiumModalOpen(false) }}>

                                        <div className="button-text">
                                            Read more
                                        </div>
                                        <img className="button-icon" src={Chevron} alt="chevron" />

                                    </button>
                                </Link>

                                {!user ?


                                    <Link to="/profile">
                                        <button className="button secondary" onClick={() => {
                                            setPremiumModalOpen(false);
                                            setSignUpFlow('register');
                                        }}>
                                            <div className="button-text">
                                                Purchase
                                            </div>
                                            <img className="button-icon" src={Chevron} alt="chevron" />
                                        </button>
                                    </Link>

                                    :

                                    <button className="button secondary" onClick={() => {
                                        setPurchaseButtonClicked(true);
                                        checkout();
                                    }}>
                                        <div className="button-text">
                                            Purchase
                                        </div>
                                        <img className="button-icon" src={Chevron} alt="chevron" />
                                    </button>


                                }

                            </>
                        }
                    </div>
                </motion.div>
            </div>



        );

    }

    return (

        <>
            {(premiumModalOpen) ?
                <PremiumModal />

                :
                <></>
            }

            {(deleteModalOpen) ?
                <DeleteModal />
                :
                <></>
            }


        </>
    );




}



export default Modal;
